import api from "../../../services/axiosConfig";
import { MODULE_INSTANCE_CONFIG, checkDependencies } from "./InstanceConfig";

export const createContainer = async (
  title,
  cardStatus,
  setCardStatus,
  setLoading,
  setContainerIds,
  toast,
  setExposedPorts,
) => {
  if (["CREATED", "RUNNING", "STOPPED"].includes(cardStatus[title])) {
    toast.current?.show({
      severity: "info",
      summary: "Info",
      detail:
        "Instance Already Created, You Can Only Create One Instance From Each Module",
    });
    return;
  }

  const config = MODULE_INSTANCE_CONFIG[title];
  if (!config) {
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: `Unknown module: ${title}`,
    });
    return;
  }
  if (!checkDependencies(title, cardStatus, toast)) return;

  setLoading((prev) => ({ ...prev, [title]: true }));
  try {
    const response = await api.post(
      `/instances/${config.url}/start`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
    const data = response.data?.data?.instances || [
      response.data?.data?.instance,
    ];
    const instances = Array.isArray(data) ? data.flat() : [data];
    const instance = config.containerFilter
      ? instances.find((i) => i.containerName?.includes(config.containerFilter))
      : instances[0];

    if (instance) {
      setContainerIds((prev) => ({ ...prev, [title]: instance.containerId }));
      setCardStatus((prev) => ({ ...prev, [title]: instance.status }));
      if (instance.exposedPorts)
        setExposedPorts((prev) => ({
          ...prev,
          [title]: instance.exposedPorts,
        }));
    }

    toast.current?.show({
      severity: "success",
      summary: "Success",
      detail: "Instance Created Successfully",
    });
  } catch (error) {
    if (error.response?.status === 403) {
      toast.current?.show({
        severity: "error",
        summary: "Permission Denied",
        detail: "You don't have permission to access this resource",
      });
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message || "Failed to Create Instance",
      });
    }
    console.error("Error during createContainer:", error);
  } finally {
    setLoading((prev) => ({ ...prev, [title]: false }));
  }
};
